import { useNavigate } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import { ButtonWrapper } from "src/pages/Settings/AccountDetails/AccountDetails.styled";
import { PageContainer } from "src/styled";

const FleetCrewSetUp = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper>
          <Button
            onClick={() => navigate("/management/crew-set-up/crew-transfer")}>
            Crew Transfer Menu
          </Button>
        </ButtonWrapper>
      </Breadcrumbs>
      {/* <UserList onUserSelect={handleEditUser} /> */}
    </PageContainer>
  );
};
export default FleetCrewSetUp;
